// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, string } from 'prop-types'
import Coordination from './Coordination'
import Location from './Location'
import MultiSelects from './MultiSelects'
import Path from './Path'
import Sites from './Sites'
import { clearDbSearchForm } from 'redux/modules/databaseSearches'
import { ActionButtons } from '../../common'

const rowClasses = 'display-flex justify-content-between align-items-start'
const mainColumnClasses = 'path-db-search-main-columns flex-1'

const skinnyCol = { width: '12%' }

const Search = ({ hasResults, idRoot, sourceForm }) => (
  <div className={'padding-1'}>
    <ul className={`${rowClasses} position-relative z-index-2`}>
      <li className={mainColumnClasses}>
        <Sites idRoot={idRoot} />
      </li>
      <li className={mainColumnClasses}>
        <MultiSelects
          idRoot={idRoot}
          sourceForm={sourceForm} />
      </li>
      <li
        className={'database-search-actions position-relative flex-direction-column'}
        style={skinnyCol}>
        <ActionButtons
          clearForm={clearDbSearchForm}
          dbSet={'path'}
          hasResults={hasResults}
          idRoot={idRoot}
          sourceForm={sourceForm} />
      </li>
    </ul>
    <ul className={`${rowClasses} margin-top-1 padding-top-1`}>
      <li className={mainColumnClasses}>
        <Coordination
          idRoot={idRoot} />
      </li>
      <li className={mainColumnClasses}>
        <Path
          idRoot={idRoot}
          sourceForm={sourceForm} />
      </li>
      <li style={skinnyCol}>
        <Location
          idRoot={idRoot}
          sourceForm={sourceForm} />
      </li>
    </ul>
  </div>
)

Search.propTypes = {
  hasResults: bool.isRequired,
  idRoot: string.isRequired,
  sourceForm: string.isRequired,
}

export default Search
